<template>
  <div class="i-resume-builder">
    <div class="banner banner1">
      Lifetime Access <img :src="JRRTinyStarT" /> $32 <img :src="JRRTinyStarT" /> One Payment
      <img :src="JRRTinyStarT" /> No Renewals
    </div>
    <div class="banner banner2"><img :src="JRRTinyStarG" />Exclusive Patnership Offer<img :src="JRRTinyStarG" /></div>
    <img
      class="progress"
      :src="isMdOrLarger ? JRRProgress : JRRProgressMob"
    />
    <div class="product">
      <div class="lead">
        <img
          class="logo"
          :src="JRRLogo"
        />
        <div class="specification">
          <img
            class="percent"
            :src="JRR86Off"
          />
          <div class="chance">
            Last chance
            <img
              class="squiggle"
              :src="JRRSquiggle"
            />
          </div>
          <div class="access">Lifetime Access to the<span class="grad-text blue-grad">#1 AI Resume Builder</span></div>
          <div class="step">
            You’re already one step ahead with your Career Report. Now
            <strong>let’s build a resume that gets you hired faster.</strong>
          </div>
        </div>
      </div>
      <div class="trust">
        <div class="rate">Excellent <img :src="JRRTrustpilotStars" /></div>
        <div class="slider">
          <iBaseAnimatedSlider
            class="slide"
            sliding-direction="left"
            animation-duration-secs="45"
          >
            <div class="emails">
              <div
                v-for="(email, i) in [...EMAILS]"
                :key="i"
                class="email"
              >
                {{ email }} lifetime plan
              </div>
            </div>
          </iBaseAnimatedSlider>
        </div>
        <div class="key-note">
          <img
            class="circle"
            :src="PurpleCircle"
          />1100+ purchases in the last hour
        </div>
      </div>
      <div class="action">
        <iBaseButton
          v-bind="buttonStyle"
          text="Lock In Lifetime Access | 86% Off"
          background-image="linear-gradient(90deg, #2097D6 33.17%, #68EAF5 92.31%)"
          @clicked="goToPlanDetails"
        ></iBaseButton>
        <div class="keywords">
          <span>Unlimited Downloads</span>
          <img :src="JRRTinyStarO" />
          <span>One Payment</span>
          <img :src="JRRTinyStarO" />
          <span>No Renewals</span>
        </div>
      </div>
    </div>
    <img
      class="preview"
      :src="isMdOrLarger ? JRRBanner : JRRBannerMob"
    />
    <div class="deets-wrap">
      <div class="whys-wrap">
        <div class="need">
          <span class="regular">You May Not Need a Resume Today...</span>
          <span class="grad-text orange-grad">...but You'll Need it Soon.</span>
        </div>
        <div class="star-divider">
          <img :src="JRRTinyStarO" />
          <img :src="JRRTinyStarO" />
          <img :src="JRRTinyStarO" />
        </div>
        <div class="why-intro">
          <span>Don’t Miss Out.</span>
          <span>Upgrade & Unlock — <strong>For Life!</strong></span>
        </div>
        <div class="whys">
          <div
            v-for="item in WHY_DATA"
            :key="item"
            class="why"
          >
            <img :src="iconTick" /> {{ item }}
          </div>
        </div>
      </div>
      <div
        id="plan-details"
        class="exclusive"
      >
        <img
          class="deal"
          :src="JRRExclusiveDeal"
        />
        <div class="price">
          <img
            class="logo-dob"
            :src="JRRLogoDouble"
          />
          $32.95
        </div>
        <div>
          <div class="off">86% OFF</div>
          <span class="slash">$235.03</span>
        </div>
        <div class="offer">Offer only available to JobTest Users</div>
      </div>
      <div class="key-note">
        <img
          class="circle"
          :src="OrangeCircle"
        />Only 7 lifetime licenses remaining
      </div>
      <div class="action">
        <iBaseButton
          v-bind="buttonStyle"
          :text="paymentProcessing ? 'Processing...' : 'Buy AI Resume Builder For Just $32.95!'"
          :is-disabled="paymentProcessing"
          @clicked="processInvoiceCharge"
        ></iBaseButton>
        <div class="keywords">
          <span>Lifetime Access</span>
          <img :src="JRRTinyStarO" />
          <span>One Payment</span>
          <img :src="JRRTinyStarO" />
          <span>No Renewals</span>
        </div>
        <div
          v-if="!paymentProcessing"
          class="skip"
          @click="goToHome"
        >
          Skip
        </div>
      </div>
    </div>
    <img
      class="short-divider"
      :src="JRRShortDividerMob"
    />
    <div class="perks-wrap">
      <div class="perks">
        <div
          v-for="(perk, i) in perks.filter((e) => e.isVisible)"
          :key="i"
          class="perk"
          :class="{ long: i === 1 }"
        >
          <div class="intro">{{ perk.intro }}</div>
          <div class="sub">{{ perk.sub }}</div>
          <img
            class="image"
            :src="perk.image"
          />
          <div
            v-if="isDesktopOrLarger && i === 1"
            class="action"
          >
            <iBaseButton
              v-bind="buttonStyle"
              :text="paymentProcessing ? 'Processing...' : 'Buy AI Resume Builder For Just $32.95!'"
              :is-disabled="paymentProcessing"
              @clicked="processInvoiceCharge"
            ></iBaseButton>
            <div class="keywords">
              <span>Lifetime Access</span>
              <img :src="JRRTinyStarO" />
              <span>One Payment</span>
              <img :src="JRRTinyStarO" />
              <span>No Renewals</span>
            </div>
            <div
              v-if="!paymentProcessing"
              class="skip"
              @click="goToHome"
            >
              Skip
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!isDesktopOrLarger"
        class="action"
      >
        <iBaseButton
          v-bind="buttonStyle"
          :text="paymentProcessing ? 'Processing...' : 'Buy AI Resume Builder For Just $32.95!'"
          :is-disabled="paymentProcessing"
          @clicked="processInvoiceCharge"
        ></iBaseButton>
        <div class="keywords">
          <span>Lifetime Access</span>
          <img :src="JRRTinyStarO" />
          <span>One Payment</span>
          <img :src="JRRTinyStarO" />
          <span>No Renewals</span>
        </div>
        <div
          v-if="!paymentProcessing"
          class="skip"
          @click="goToHome"
        >
          Skip
        </div>
      </div>
    </div>
    <div class="warn-wrap">
      <div class="warn-box grad-box">
        <div class="warn">
          <img
            class="warn-icon"
            :src="JRRTime"
          />
          <div class="head">🚨This is your only shot at lifetime access! 🚨</div>
          <div class="down">
            <span>This one-time upgrade is only available to JobTest users — and only during this annual promo.</span>
            <span>JobTest is covering part of the cost to keep this affordable.</span>
            <span>That’s why this window is brief and <strong>will not be shown again until next year.</strong></span>
          </div>
        </div>
      </div>
      <div class="action">
        <iBaseButton
          v-bind="buttonStyle"
          :text="paymentProcessing ? 'Processing...' : 'Buy AI Resume Builder For Just $32.95!'"
          :is-disabled="paymentProcessing"
          @clicked="processInvoiceCharge"
        ></iBaseButton>
        <div class="keywords">
          <span>Lifetime Access</span>
          <img :src="JRRTinyStarO" />
          <span>One Payment</span>
          <img :src="JRRTinyStarO" />
          <span>No Renewals</span>
        </div>
        <div
          v-if="!paymentProcessing"
          class="skip"
          @click="goToHome"
        >
          Skip
        </div>
      </div>
    </div>
    <div class="reviews">
      <div
        v-for="(reviews, i) in REVIEWS"
        :key="i"
        class="review"
      >
        <div class="main">
          <img
            class="stars"
            :src="JRRStars"
          />
          <div class="name">{{ reviews.name }}</div>
          <div>{{ reviews.comment }}</div>
        </div>
        <div class="time">{{ reviews.time }}</div>
      </div>
    </div>
    <div class="keys-wrap">
      <div class="keys">
        <div
          v-for="(keys, i) in KEYS"
          :key="i"
          class="key-wrap grad-box"
        >
          <div class="key">
            <img
              class="key-icon"
              :src="keys.icon"
            />
            <div class="bold">{{ keys.head }}</div>
            <div>{{ keys.sub }}</div>
          </div>
        </div>
      </div>
      <div class="action">
        <iBaseButton
          v-bind="buttonStyle"
          :text="paymentProcessing ? 'Processing...' : 'Buy AI Resume Builder For Just $32.95!'"
          :is-disabled="paymentProcessing"
          @clicked="processInvoiceCharge"
        ></iBaseButton>
        <div class="keywords">
          <span>Lifetime Access</span>
          <img :src="JRRTinyStarO" />
          <span>One Payment</span>
          <img :src="JRRTinyStarO" />
          <span>No Renewals</span>
        </div>
        <div
          v-if="!paymentProcessing"
          class="skip"
          @click="goToHome"
        >
          Skip
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import router from "@/router"
import { useUserStore } from "@/stores/user"
import { white } from "@/styles/colors"
import { breakpointLg, breakpointSm, breakpointMd } from "@/styles/variables"
import { computed, onMounted, ref } from "vue"

import useIsScreenSize from "@/composables/useIsScreenSize"
import { GlobalVariables } from "@/helpers/globalVariables"
import api from "@/services/apiClient"
import ErrorService from "@/services/errorService"

import iBaseButton from "@/components/base/BaseButton.vue"
import iBaseAnimatedSlider from "@/components/base/BaseAnimatedSlider.vue"

// ASSETS
import iconTick from "@/assets/icons/icon-green-check.svg"
import JRRPerkSample from "@/assets/images/jrr-sample-mob.svg"
import JRRPerkResume from "@/assets/images/jrr-resume-mob.svg"
import JRRPerkAI from "@/assets/images/jrr-ai-mob.svg"
import JRRLogo from "@/assets/images/jrr-logo.svg"
import JRRBanner from "@/assets/images/jrr-banner.svg"
import JRRBannerMob from "@/assets/images/jrr-banner-mob.svg"
import JRRProgress from "@/assets/images/jrr-progress.svg"
import JRRProgressMob from "@/assets/images/jrr-progress-mob.svg"
import JRR86Off from "@/assets/images/jrr-86-off.svg"
import JRRSquiggle from "@/assets/images/jrr-squiggle.svg"
import JRRExclusiveDeal from "@/assets/images/jrr-exclusive-deal.svg"
import JRRStars from "@/assets/images/purple-stars.svg"
import JRRTrustpilotStars from "@/assets/images/jrr-trustpilot-stars.svg"
import JRRTinyStarO from "@/assets/images/tiny-star-orange.svg"
import JRRTinyStarT from "@/assets/images/tiny-star-translucent.svg"
import JRRTinyStarG from "@/assets/images/tiny-star-group.svg"
import JRRDollar from "@/assets/images/jrr-dollar.svg"
import JRRSpark from "@/assets/images/jrr-spark.svg"
import JRRTarget from "@/assets/images/jrr-target.svg"
import JRRAPlus from "@/assets/images/jrr-a-plus.svg"
import JRRTime from "@/assets/icons/icon-time-gradient.svg"
import OrangeCircle from "@/assets/images/orange-circle.svg"
import PurpleCircle from "@/assets/images/purple-circle.svg"
import JRRLogoDouble from "@/assets/images/jrr-logo-double.svg"
import JRRShortDividerMob from "@/assets/images/jrr-short-divider-mob.svg"

// TYPES
import ApiClient, { ApiError } from "@/shared/apiClient"
import StripePrice from "@/shared/enums/StripePrice"

// STORES AND COMPOSABLES
const userStore = useUserStore()
const isDesktopOrLarger = useIsScreenSize(breakpointLg)
const isSmOrLarger = useIsScreenSize(breakpointSm)
const isMdOrLarger = useIsScreenSize(breakpointMd)

// CONSTANTS
const STRIPE_IDEMPOTENCY_KEY = ApiClient.generateIdempotencyKey()
const EMAILS = [
  "sophia.br***",
  "michael.da***",
  "julia.ro***",
  "ethan.ma***",
  "olivia.st***",
  "daniel.ke***",
  "isabella.ch***",
  "liam.th***",
  "ava.pe***",
  "noah.re***",
  "mia.pa***",
  "jack.so***",
  "amelia.ha***",
  "lucas.gr***",
  "ella.mi***",
  "henry.co***",
  "chloe.be***",
  "sebastian.lo***",
  "zoe.cl***",
  "aiden.ri***"
]
const WHY_DATA = [
  "Sound instantly more professional.",
  "Match every job you apply for.",
  "Be seen in seconds, not skipped.",
  "Say things clearly and confidently.",
  "Pass the recruiter’s quick scan.",
  "Make your resume effortless to skim.",
  "Show real impact with real numbers.",
  "Turn soft skills into proof.",
  "Download in any format you need.",
  "Know exactly what to improve.",
  "Edit anytime. Keep it forever.",
  "Tailor your resume instantly."
]
const REVIEWS = [
  {
    name: "Sophia R.",
    comment:
      "The AI blew me away. It instantly turned my messy draft into a professional resume that landed me interviews within a week. So easy to use!",
    time: "about 6 hours ago"
  },
  {
    name: "Lena C.",
    comment:
      "This resume builder is awesome. The templates look sharp, but the real magic is the AI suggestions—it made my resume sound confident and polished without me overthinking it.",
    time: "about 6 hours ago"
  },
  {
    name: "Marcus H.",
    comment:
      "I was skeptical about AI, but JobReadyResume proved me wrong. It tailored my resume to the job I wanted in minutes. Highly recommend!",
    time: "about 10 hours ago"
  },
  {
    name: "Rachel P.",
    comment:
      "Super intuitive and way faster than doing it myself. The AI guided me through every step and gave me wording I never would have thought of.",
    time: "about 11 hours ago"
  },
  {
    name: "Johnathan S.",
    comment:
      "Amazing tool. It feels like having a personal resume coach built right in. The AI edits were spot-on and made my resume stand out.",
    time: "about 12 hours"
  },
  {
    name: "Emily T.",
    comment:
      "I love how smart the AI is. It doesn't just format—it actually strengthens my experiences so they read like achievements. Total game-changer.",
    time: "about 15 hours ago"
  },
  {
    name: "Carlos V.",
    comment:
      "This site saved me hours. The AI took my scattered notes and turned them into a clean, professional resume. Honestly feels like magic.",
    time: "1 day ago"
  }
]
const KEYS = [
  {
    icon: JRRDollar,
    head: "Get paid 7% more",
    sub: "Resumes that land a higher starting salary..."
  },
  {
    icon: JRRSpark,
    head: "Create in 10 mins",
    sub: "The AI builder is 10 x faster than doing on your own."
  },
  {
    icon: JRRTarget,
    head: "ATS templates",
    sub: "Your resume will be 100% compliant so recruiters see you."
  },
  {
    icon: JRRAPlus,
    head: "Zero mistakes",
    sub: "Don't stress over typos; you'll sound great!"
  }
]

// REFS
const paymentProcessing = ref(false)

// COMPUTED
const buttonStyle = computed(() => {
  return {
    size: isSmOrLarger.value ? "large" : "medium",
    fontWeight: "700",
    width: isSmOrLarger.value ? "fit-content" : "100%",
    backgroundImage: "linear-gradient(0deg, #EF4444 0%, #FF7300 100%)",
    borderRadius: "48px",
    textColor: white,
    isHoverable: true
  }
})

const perks = computed(() => [
  {
    intro: "Quick and Simple to Use",
    sub: "With our AI resume writer, you can produce a tailored resume with ease.",
    image: JRRPerkSample,
    isVisible: true
  },
  {
    intro: "Powered by OpenAI's GPT-5, Trained by Recruiters",
    sub: "Our AI resume builder is powered by the latest and most advanced version of OpenAI's ChatGPT-5 model. It also connects to Azure's OpenAI which features the most advanced Natural Language Processing (NLP) models.",
    image: JRRPerkAI,
    isVisible: isDesktopOrLarger.value
  },
  {
    intro: "ATS Friendly & Optimized",
    sub: "Our professional Recruiter-Built, Harvard-inspired resume templates are fully compatible with Applicant Tracking Systems. Creating an ATS-friendly resume increases your chances of getting hired by 83%!",
    image: JRRPerkResume,
    isVisible: true
  },
  {
    intro: "Powered by OpenAI's GPT-5, Trained by Recruiters",
    sub: "Our AI resume builder is powered by the latest and most advanced version of OpenAI's ChatGPT-5 model. It also connects to Azure's OpenAI which features the most advanced Natural Language Processing (NLP) models.",
    image: JRRPerkAI,
    isVisible: !isDesktopOrLarger.value
  }
])

// FUNCTIONS
const goToHome = async () => {
  await Promise.allSettled([await userStore.loadUserData(), await api.event.postEvent("resumeBuilderInterestNo")])
  router.push({ name: GlobalVariables.urls.report.children.home.routeName })
}

const goToPlanDetails = () => {
  const planDetails = document.querySelector("#plan-details")
  const firstBanner = document.querySelector(".banner1")
  if (!planDetails) return

  let offset = 20
  if (firstBanner) offset = firstBanner.getBoundingClientRect().height + offset

  // Calculate the target scroll position and scroll to
  const targetScrollPosition = planDetails.getBoundingClientRect().top + window.scrollY - offset
  window.scrollTo({ top: targetScrollPosition, behavior: "smooth" })
}

const processInvoiceCharge = async () => {
  paymentProcessing.value = true
  try {
    await Promise.allSettled([
      await api.event.postEvent("resumeBuilderInterestYes"),
      await api.stripe.postInvoiceCharge({
        stripePrices: [StripePrice.RESUME_BUILDER_FEASIBILITY],
        idempotencyKey: STRIPE_IDEMPOTENCY_KEY
      })
    ])

    router.push({ name: GlobalVariables.urls.resumeBuilder.children.confirmation.routeName })
  } catch (error) {
    ErrorService.redirect(error as ApiError)
  } finally {
    paymentProcessing.value = false
  }
}

// LIFECYCLE HOOKS
onMounted(() => {
  if (userStore.userData?.hasResumeBuilderPackage) goToHome()
})
</script>

<style scoped lang="scss">
.i-resume-builder {
  @include flex(column, start, center);

  overflow: clip;

  .banner {
    @include text-xs;

    color: $white;
    width: 100%;

    @media screen and (min-width: $breakpoint-sm) {
      @include text-sm;
    }

    @media screen and (min-width: $breakpoint-md) {
      @include text-lg;
    }
  }

  .banner1 {
    @include flex(row, center, center, $gap: 5px);

    background: linear-gradient(90deg, #2083b7 33.17%, #21c7d5 92.31%);
    font-weight: 700;
    padding: 10px;
    position: sticky;
    top: 0;
    z-index: 1000;

    @media screen and (min-width: $breakpoint-sm) {
      gap: 15px;
    }

    @media screen and (min-width: $breakpoint-lg) {
      @include text-xl;
    }
  }

  .banner2 {
    @include flex(row, center, center, $gap: 5px);

    background-color: $black;
    font-weight: 400;
    padding: 10px;

    @media screen and (min-width: $breakpoint-lg) {
      @include text-xxl;
    }

    img {
      width: 70px;

      @media screen and (min-width: $breakpoint-sm) {
        width: 115px;
      }
    }
  }

  .progress {
    padding: 15px 15px 0;

    @media screen and (min-width: $breakpoint-md) {
      width: 600px;
    }

    @media screen and (min-width: $breakpoint-lg) {
      width: 700px;
    }
  }

  .product {
    @include flex(column, start, center);

    padding: 15px 0;

    .lead {
      @include flex(column, start, center, $gap: 18px);

      @media screen and (min-width: $breakpoint-md) {
        gap: 50px;
      }

      .logo {
        width: 180px;

        @media screen and (min-width: $breakpoint-md) {
          width: 270px;
        }

        @media screen and (min-width: $breakpoint-lg) {
          width: 348px;
        }
      }

      .specification {
        @include flex(column, start, center);

        position: relative;

        .percent {
          position: absolute;
          top: -18%;
          right: -4%;
          width: 100px;

          @media screen and (min-width: $breakpoint-md) {
            width: 180px;
            right: -10%;
            top: -25%;
          }

          @media screen and (min-width: $breakpoint-lg) {
            width: 247px;
            right: -85px;
            top: -29%;
          }
        }

        .chance {
          @include display-sm;

          position: relative;
          text-align: center;

          @media screen and (min-width: $breakpoint-md) {
            @include display-lg;
          }

          @media screen and (min-width: $breakpoint-lg) {
            @include display-xl;
          }

          .squiggle {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translateX(-50%);
            z-index: -1;
            width: 180px;

            @media screen and (min-width: $breakpoint-md) {
              width: 290px;
            }

            @media screen and (min-width: $breakpoint-lg) {
              width: 383px;
            }
          }
        }

        .access {
          @include flex(column, center, center, $gap: 5px);
          @include display-sm;

          text-align: center;

          @media screen and (min-width: $breakpoint-md) {
            @include display-lg;
          }

          @media screen and (min-width: $breakpoint-lg) {
            @include display-xl;
          }

          .blue-grad {
            background-image: linear-gradient(90deg, #2c7ce7 23.56%, #1e9bb8 62.02%, #00ebff 91.35%);
          }
        }

        .step {
          @include text-lg;

          margin-top: 15px;
          text-align: center;
          max-width: 325px;

          @media screen and (min-width: $breakpoint-md) {
            @include display-xs;

            margin-top: 30px;
            max-width: 460px;
          }

          @media screen and (min-width: $breakpoint-lg) {
            @include display-md;

            max-width: 630px;
          }
        }
      }
    }

    .trust {
      @include flex(column, end, stretch, $gap: 20px);

      background-image: url("@/assets/images/jrr-long-divider.png");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      width: 100%;
      max-width: 400px;

      @media screen and (min-width: $breakpoint-md) {
        background-position: center top;
        gap: 45px;
        max-width: 700px;
      }

      @media screen and (min-width: $breakpoint-lg) {
        max-width: 900px;
      }

      .rate {
        @include flex(row, center, center, $gap: 15px);
        @include text-xl;

        font-weight: 400;
        margin-top: 50px;

        @media screen and (min-width: $breakpoint-md) {
          @include display-md;

          margin-top: 90px;
        }

        @media screen and (min-width: $breakpoint-lg) {
          @include display-lg;

          margin-top: 110px;
        }

        img {
          width: 115px;

          @media screen and (min-width: $breakpoint-md) {
            width: 200px;
          }

          @media screen and (min-width: $breakpoint-lg) {
            width: 262px;
          }
        }
      }

      .slider {
        @include flex(column, center, center);

        .slide {
          width: 100%;

          .emails {
            @include flex(row, center, center, $gap: 15px);

            .email {
              @include border-radius-xs;
              @include text-md;

              width: max-content;
              font-weight: 500;
              background-color: #0000000f;
              padding: 2px 16px;

              @media screen and (min-width: $breakpoint-md) {
                @include display-xs;
                @include border-radius-sm;
              }

              @media screen and (min-width: $breakpoint-lg) {
                @include display-sm;
              }
            }
          }
        }
      }
    }

    .action {
      margin-top: 25px;
    }
  }

  .preview {
    width: 100%;
    max-width: 100vw;
  }

  .deets-wrap {
    @include flex(column, start, stretch, $gap: 25px);

    padding: 20px 15px 15px;

    @media screen and (min-width: $breakpoint-md) {
      align-items: center;
      padding: 0 15px 15px;
    }

    .whys-wrap {
      @include flex(column, center, stretch, $gap: 15px);

      @media screen and (min-width: $breakpoint-md) {
        gap: 22px;
      }

      .need {
        @include flex(column, center, center, $gap: 5px);
        @include display-sm;

        text-align: center;

        @media screen and (min-width: $breakpoint-md) {
          @include display-md;
        }

        @media screen and (min-width: $breakpoint-lg) {
          @include display-lg;
        }

        .regular {
          max-width: 380px;

          @media screen and (min-width: $breakpoint-md) {
            max-width: 420px;
          }

          @media screen and (min-width: $breakpoint-lg) {
            max-width: 550px;
          }
        }

        .orange-grad {
          background-image: linear-gradient(90deg, #ef4444 0%, #ff7300 100%);
        }
      }

      .star-divider {
        @include flex(row, center, center, $gap: 10px);

        img {
          width: 10px;

          @media screen and (min-width: $breakpoint-md) {
            width: 15px;
          }

          @media screen and (min-width: $breakpoint-lg) {
            width: 20px;
          }
        }
      }

      .why-intro {
        @include flex(column, center, center);
        @include text-xl;

        text-align: center;

        @media screen and (min-width: $breakpoint-md) {
          @include display-sm;

          gap: 4px;
        }

        @media screen and (min-width: $breakpoint-lg) {
          @include display-md;
        }
      }

      .whys {
        @include flex(column, start, stretch, $gap: 10px);
        @include text-lg;

        margin: auto;

        @media screen and (min-width: $breakpoint-md) {
          @include text-xxl;

          max-width: 470px;
          gap: 15px;
        }

        @media screen and (min-width: $breakpoint-lg) {
          @include display-sm;

          max-width: 580px;
        }

        .why {
          @include flex(row, start, center, $gap: 10px);

          img {
            width: 18px;

            @media screen and (min-width: $breakpoint-lg) {
              width: 22px;
            }
          }
        }
      }
    }

    .exclusive {
      @include flex(column, start, stretch, $gap: 10px);
      @include border-radius-md;

      margin-top: 25px;
      position: relative;
      padding: 15px;
      background-color: $azure-radiance100;

      @media screen and (min-width: $breakpoint-md) {
        margin-top: 35px;
        padding: 25px;
        gap: 15px;
        min-width: 603px;
      }

      > div {
        @include flex(row, space-between, center, $gap: 5px);

        font-weight: 700;
      }

      .deal {
        position: absolute;
        top: -25%;
        right: 0;
        width: 80px;

        @media screen and (min-width: $breakpoint-xs) {
          width: 80px;
          top: -15%;
        }

        @media screen and (min-width: $breakpoint-md) {
          width: 120px;
          top: -20%;
        }
      }

      .price {
        @include display-sm;

        @media screen and (min-width: $breakpoint-xs) {
          @include display-lg;
        }

        @media screen and (min-width: $breakpoint-md) {
          @include display-xxl;
        }

        .logo-dob {
          width: 150px;

          @media screen and (min-width: $breakpoint-xs) {
            width: 170px;
          }

          @media screen and (min-width: $breakpoint-md) {
            width: 255px;
          }
        }
      }

      .off {
        @include text-sm;
        @include border-radius-xxl;

        background-color: $white;
        padding: 0 8px;

        @media screen and (min-width: $breakpoint-xs) {
          @include text-lg;
        }

        @media screen and (min-width: $breakpoint-md) {
          @include display-sm;
        }
      }

      .slash {
        @include text-md;

        color: $black400;
        text-decoration: line-through;

        @media screen and (min-width: $breakpoint-xs) {
          @include text-xxl;
        }

        @media screen and (min-width: $breakpoint-md) {
          @include display-md;
        }
      }

      .offer {
        @include text-xs;

        font-style: italic;
        font-weight: 400;

        @media screen and (min-width: $breakpoint-md) {
          @include text-xxl;
        }
      }
    }
  }

  .short-divider {
    width: 100vw;

    @media screen and (min-width: $breakpoint-md) {
      width: 100%;
      max-width: 750px;
    }

    @media screen and (min-width: $breakpoint-lg) {
      max-width: 1055px;
    }
  }

  .perks-wrap {
    @include flex(column, start, stretch, $gap: 25px);

    padding: 0 15px 15px;

    @media screen and (min-width: $breakpoint-md) {
      padding: 30px 15px 15px;
    }

    .perks {
      @include flex(column, start, stretch, $gap: 25px);

      @media screen and (min-width: $breakpoint-sm) {
        align-items: center;
        gap: 40px;
      }

      @media screen and (min-width: $breakpoint-lg) {
        @include grid($cols: repeat(2, 1fr), $rows: minmax(100px, auto), $align-items: start, $gap: 55px);
      }

      .perk {
        @include flex(column, start, stretch, $gap: 5px);
        @include text-md;

        font-weight: 400;
        max-width: 500px;

        @media screen and (min-width: $breakpoint-lg) {
          &.long {
            grid-row-end: span 2; /* This item will span two rows vertically */
          }
        }

        .intro {
          @include text-xxl;

          font-weight: 700;
        }

        .sub {
          max-width: 1000px;
        }

        .image {
          width: 100%;
          margin: 10px auto 0;
        }

        .action {
          margin-top: 140px;
        }
      }
    }
  }

  .warn-wrap {
    @include flex(column, start, stretch, $gap: 25px);

    padding: 15px;

    .warn-box {
      @include border-radius-md;

      max-width: 450px;

      @media screen and (min-width: $breakpoint-md) {
        @include border-radius-lg;

        max-width: 630px;
      }

      .warn {
        @include flex(column, start, center, $gap: 15px);
        @include text-xs;

        padding: 10px 20px;
        font-weight: 400;
        background-color: $white;
        border-radius: 11px;
        text-align: center;

        @media screen and (min-width: $breakpoint-md) {
          border-radius: 23px;
          gap: 20px;
          padding: 20px 30px;
        }

        .warn-icon {
          width: 32px;

          @media screen and (min-width: $breakpoint-md) {
            width: 54px;
          }
        }

        .head {
          @include text-xxl;

          font-weight: 700;

          @media screen and (min-width: $breakpoint-md) {
            @include display-md;
          }
        }

        .down {
          @include flex(column, start, stretch, $gap: 20px);
          @include text-lg;

          margin-top: 10px;

          @media screen and (min-width: $breakpoint-md) {
            @include display-sm;

            gap: 30px;
          }
        }
      }
    }
  }

  .reviews {
    @include flex(row, center, stretch, wrap, 20px);

    max-width: 1100px;
    padding: 15px;

    .review {
      @include flex(column, space-between, stretch, $gap: 6px);
      @include border-radius-sm;
      @include text-sm;

      padding: 15px;
      border: 1px solid $zumthor100;
      color: $comet800;
      font-weight: 400;
      width: 100%;
      max-width: 450px;

      @media screen and (min-width: $breakpoint-md) {
        @include text-lg;

        width: 450px;
      }

      .main {
        @include flex(column, start, stretch, $gap: 4px);

        .stars {
          width: 80px;

          @media screen and (min-width: $breakpoint-md) {
            width: 100px;
          }
        }

        .name {
          @include text-md;

          font-weight: 600;
          color: $black;

          @media screen and (min-width: $breakpoint-md) {
            @include text-xl;
          }
        }
      }

      .time {
        @include text-xs;

        color: $comet600;

        @media screen and (min-width: $breakpoint-md) {
          @include text-md;
        }
      }
    }
  }

  .keys-wrap {
    @include flex(column, start, stretch, $gap: 25px);

    padding: 15px;

    .keys {
      @include flex(column, center, center, $gap: 12px);

      @media screen and (min-width: $breakpoint-xxs) {
        @include grid($cols: repeat(2, 1fr), $rows: repeat(2, 1fr), $align-items: stretch, $gap: 12px);
      }

      @media screen and (min-width: $breakpoint-md) {
        gap: 20px;
      }

      .key-wrap {
        @include border-radius-md;

        max-width: 205px;

        @media screen and (min-width: $breakpoint-md) {
          @include border-radius-xl;

          max-width: 375px;
        }

        .key {
          @include flex(column, start, stretch, $gap: 15px);
          @include text-xs;

          padding: 8px;
          color: $comet800;
          font-weight: 400;
          background-color: $pickle-bluewood50;
          height: 100%;
          border-radius: 11px;

          @media screen and (min-width: $breakpoint-xs) {
            padding: 15px;
          }

          @media screen and (min-width: $breakpoint-md) {
            @include text-xxl;

            border-radius: 30px;
            gap: 20px;
            padding: 20px;
          }

          @media screen and (min-width: $breakpoint-lg) {
            @include display-xs;
          }

          .key-icon {
            width: 35px;

            @media screen and (min-width: $breakpoint-md) {
              width: 50px;
            }

            @media screen and (min-width: $breakpoint-lg) {
              width: 70px;
            }
          }

          .bold {
            @include text-md;

            color: $black;

            @media screen and (min-width: $breakpoint-md) {
              @include display-sm;
            }

            @media screen and (min-width: $breakpoint-lg) {
              @include display-md;
            }
          }
        }
      }
    }
  }

  .grad-box {
    @include text-md;

    width: 100%;
    font-weight: 600;
    background-image: $blue-purple-gradient;
    padding: 2px;
  }

  .grad-text {
    font-weight: 700;
    color: transparent;
    background-clip: text;
  }

  .key-note {
    @include flex(row, center, center, $gap: 6px);
    @include text-lg;

    font-weight: 700;

    @media screen and (min-width: $breakpoint-md) {
      @include display-xs;
    }

    @media screen and (min-width: $breakpoint-lg) {
      @include display-md;
    }

    .circle {
      @include border-radius-rounded;

      width: 15px;

      @media screen and (min-width: $breakpoint-md) {
        width: 26px;
      }

      @media screen and (min-width: $breakpoint-lg) {
        width: 30px;
      }
    }
  }

  .action {
    @include flex(column, start, center, $gap: 8px);
    @include text-sm;

    font-weight: 400;

    .keywords {
      @include flex(row, center, center, $gap: 7px);
      @include text-xs;

      font-style: italic;

      @media screen and (min-width: $breakpoint-sm) {
        @include text-sm;
      }
    }

    .skip {
      margin-top: 20px;
      color: $black300;
      text-transform: uppercase;
      text-decoration: underline;
      cursor: pointer;

      &:hover {
        color: $black500;
      }
    }
  }
}
</style>
